import { forwardRef } from 'react'
import cn from 'clsx'
import type { TListItemProps, TListProps } from './List.types'
import styles from './List.module.css'

export const List = forwardRef<HTMLUListElement, TListProps>(({ className, ...props }, ref) => (
    <ul ref={ref} className={cn(styles.list, className)} {...props} />
))

export const ListItem = forwardRef<HTMLLIElement, TListItemProps>(
    ({ children, className, ...props }, ref) => (
        <li ref={ref} className={cn(styles.item, className)} {...props}>
            {children}
        </li>
    ),
)
